import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

const WOOP_WORKLOAD_SPEC_QUERY_KEY = 'woop-workload-SPEC';

const getWorkloadSpecQueryKey = ({
  clusterId,
  workloadId,
}: { clusterId?: string; workloadId?: string } = {}) =>
  [WOOP_WORKLOAD_SPEC_QUERY_KEY, clusterId, workloadId] as const;

export type UseWorkloadSpecQueryArgs = {
  clusterId: string;
  workloadId: string;
  enabled?: boolean;
};

const getWorkloadSpecQueryOptions = ({
  clusterId,
  workloadId,
  enabled,
}: UseWorkloadSpecQueryArgs) =>
  queryOptions({
    queryKey: getWorkloadSpecQueryKey({ clusterId, workloadId }),
    queryFn: async () => {
      const { data } = await apiClient.workloadOptimization.getWorkloadSpec({
        clusterId,
        workloadId,
      });
      return data;
    },
    enabled,
  });

export const useWorkloadSpecQuery = (args: UseWorkloadSpecQueryArgs) => {
  const { data, isLoading, error, refetch } = useQuery(
    getWorkloadSpecQueryOptions(args)
  );

  return {
    data,
    isLoading,
    error,
    refetch,
  };
};
